import {RESOURCE_UPDATE, ResourceActions} from '@catfeatures/actions/resource.actions';
import {getServiceForResource} from '@catfeatures/shared/resources';
import {ResourceHandler} from '@catfeatures/types';
import {Store} from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {isNullOrUndefined} from 'util';

export class GenericResourceInMemoryHandler implements ResourceHandler {
  private httpService;

  private source = new BehaviorSubject(null);
  private source$ = this.source.asObservable();
  private current: any = null;
  private inProcess = false;

  constructor(private resourceRef: string,
              http: Restangular) {
    this.httpService = getServiceForResource(resourceRef, http);
  }

  isReady() {
    return !isNullOrUndefined(this.current) && !this.inProcess;
  }

  extractCurrent(){
    return this.current;
  }

  getCurrent(): Observable<any> {
    return this.source$;
  }

  load(): void {
    if (!this.inProcess) {
      this.inProcess = true;
      this
        .httpService
        .get()
        .subscribe((model: any) => {
          this.inProcess = false;
          this.updateCurrent(model);
        });
    }
  }

  /**
   * Updates the resource and returns the result as an observable. Can be used if an
   * immediate refresh of the resource is needed.
   */
  loadAndGet(): Observable<any> {
    return this.httpService
      .get()
      .map((model: any) => {
        this.inProcess = false;
        this.updateCurrent(model);
        return model;
      });
  }

  refresh(): void {
    if (this.current) {
      this.load();
    }
  }

  save(data: any, create: boolean = false): Observable<any> {
    const method = create ? this.httpService.customPOST : this.httpService.customPUT;
    return method(data)
      .map((result) => {
        this.refresh();
        return result;
      });
  }

  delete(): Observable<any> {
    return this.httpService
      .remove()
      .map((result) => {
        this.remove();
        return result;
      });
  }

  private updateCurrent(model) {
    if (JSON.stringify(model) !== JSON.stringify(this.current)) {
      this.current = model;
      this.source.next(this.current);
    }
  }

  private remove() {
    this.updateCurrent(null);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/shared/generic-resource-in-memory-handler.ts